export default __webpack_public_path__ + "static/media/logo-white.52600759.svg";